import { withStyles } from '@mui/styles';
import React from 'react';
import { translate } from '../../../base/i18n/functions';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { connect } from '../../../base/redux/functions';
import AbstractRecordingLabel, { _mapStateToProps
// @ts-ignore
 } from '../AbstractRecordingLabel';
// CUSTOM
// @ts-ignore
import Button from '@atlaskit/button/standard-button';
// @ts-ignore
import { dispatch } from '../../../customise/Utils';
// @ts-ignore
import { openDialog } from '../../../base/dialog';
// @ts-ignore
import { StopRecordingDialog } from '../Recording/web';
// @ts-ignore
import { setDisableRecIcon } from '../../../customise/redux/tool-webjam-v2/actions';
// @ts-ignore
import StopLiveStreamDialog from '../LiveStream/web/StopLiveStreamDialog';
import { ct } from "../../../customise/constant-Utils";
// END
/**
 * Creates the styles for the component.
 *
 * @param {Object} theme - The current UI theme.
 *
 * @returns {Object}
 */
const styles = (theme) => {
    return {
        [JitsiRecordingConstants.mode.STREAM]: {
            background: theme.palette.ui03,
        },
        [JitsiRecordingConstants.mode.FILE]: {
            background: theme.palette.iconError,
        },
    };
};
/**
 * Implements a React {@link Component} which displays the current state of
 * conference recording.
 *
 * @augments {Component}
 */
class RecordingLabel extends AbstractRecordingLabel {
    /**
     * Renders the platform specific label component.
     *
     * @inheritdoc
     */
    _renderLabel() {
        // @ts-ignore
        if (this.props._status !== JitsiRecordingConstants.status.ON) {
            // Since there are no expanded labels on web, we only render this
            // label when the recording status is ON.
            return null;
        }
        // CUSTOM
        // @ts-ignore
        // const { classes, mode, t } = this.props;
        // return (
        //     <div>
        //         <Label
        //             className = { classes?.[mode] }
        //             // @ts-ignore
        //             text = { t(this._getLabelKey()) } />
        //     </div>
        // );
        const { mode, _isModerator } = this.props;
        const recIconAction = () => {
            if (_isModerator) {
                dispatch(openDialog(StopRecordingDialog));
                dispatch(setDisableRecIcon(false));
            }
        };
        const liveIconAction = () => {
            if (_isModerator) {
                dispatch(openDialog(StopLiveStreamDialog));
                dispatch(setDisableRecIcon(false));
            }
        };
        const handleMouseIn = () => {
            this.setState({
                recordingStatus: false,
            });
        };
        const handleMouseOut = () => {
            this.setState({
                recordingStatus: true,
            });
        };
        if (mode == "stream") {
            return (React.createElement(Button, { onMouseEnter: () => handleMouseIn(), onMouseLeave: () => handleMouseOut(), className: "custom-rec-icon-active " +
                    (this.state.recordingStatus ? "active" : ""), id: "custom-recording-container", onClick: () => liveIconAction(), title: ct("rta-trmc.conference.stopLiveStreaming") }, ct("rta-trmc.conference.live")));
        }
        else {
            return (
            // <div className='default-rec-icon-active'>
            //     <Label
            //         className={classes && classes[mode]}
            //         text={t(this._getLabelKey())} />
            // </div>
            React.createElement(Button, { onMouseEnter: () => handleMouseIn(), onMouseLeave: () => handleMouseOut(), className: "custom-rec-icon-active " +
                    (this.state.recordingStatus ? "active" : ""), id: "custom-recording-container", onClick: () => recIconAction(), title: ct("rta-trmc.toolBox.stopRecording") }, ct("rta-trmc.toolBox.stopRecording")));
        }
        // END
    }
}
// @ts-ignore
export default withStyles(styles)(translate(connect(_mapStateToProps)(RecordingLabel)));
